import { Drawer as ExpoRouterDrawer } from 'expo-router/drawer'
import type { ComponentProps, ReactNode } from 'react'

import { mergePageTypeScreenOptions, usePageTypeNavigator } from '@/src/general/hooks/usePageTypeNavigator'

type TExpoDrawerProps = ComponentProps<typeof ExpoRouterDrawer>

/**
 * expo-router Drawer with page-type style baked in (opaque sceneStyle + screenLayout).
 */
const PageTypeDrawerRoot = ({ screenLayout, screenOptions, ...props }: TExpoDrawerProps): ReactNode => {
  const { pageBackgroundColor, composeScreenLayout } = usePageTypeNavigator()

  return (
    <ExpoRouterDrawer
      {...props}
      screenLayout={composeScreenLayout(screenLayout)}
      screenOptions={mergePageTypeScreenOptions('sceneStyle', pageBackgroundColor, screenOptions)}
    />
  )
}

export const Drawer = Object.assign(PageTypeDrawerRoot, {
  Screen: ExpoRouterDrawer.Screen,
  Protected: ExpoRouterDrawer.Protected,
})
